<template>
  <div class="dialogue-container">
    <div class="dialogue">
      <slot />
    </div>

    <img class="blob" src="~@/assets/images/blob-1.svg" alt="" />
    <img class="circle" src="~@/assets/images/circle-1.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'Dialogue',
};
</script>

<style lang="scss" scoped>
.dialogue-container {
  width: 100%;
  max-width: 720px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-self: center;
}

.dialogue {
  background: rgba(255, 255, 255, 0.98);
  display: flex;
  flex-direction: column;
  z-index: 20;
  text-align: center;
  align-items: center;
  box-shadow: 0 8px 24px 0px rgba(black, 0.06);
  padding: 24px;
  flex: 1;

  @media screen and (min-width: 1024px) {
    border-radius: 16px;
  }
}

.circle,
.blob {
  display: none;
}

@media screen and (min-width: 768px) {
  .dialogue-container {
    margin-top: 128px;
  }

  .circle,
  .blob {
    display: block;
    position: absolute;
    user-select: none;
    pointer-events: none;
  }

  .circle {
    bottom: 0;
    transform: translate(-40%, -100%);
  }

  .blob {
    top: -160px;
    right: -120px;
  }
}
</style>
